export default __webpack_public_path__ + "static/media/education.bc1d08d8.PNG";